import classNames from "classnames/bind";
import styles from "./NameCol.module.css";
import { DownIcon } from "../Icons/Icons";
import React, { useEffect } from "react";

const cx = classNames.bind(styles)
function NameCol({ title, handleSort, method, active }) {
    const [up, setUp] = React.useState(false);
    const [down, setDown] = React.useState(false);
    useEffect(() => {
        if(method !== active) {
            setDown(false);
            setUp(false);
        }
    }, [active, method])
    const pickUp = () => {
        handleSort('up', method); 
        setUp(!up); 
        setDown(false);
    }
    const pickDown = () => {
        handleSort('down', method); 
        setDown(!down); 
        setUp(false);
    }
    return (
        <div className={cx('name')}>
            {title}
            {/* <div className={cx('container-button')}>
                <button className={cx('button-fill-name-up', up && 'active')} onClick={() => pickUp()}><DownIcon /></button>
                <button className={cx('button-fill-name-down', down && 'active')} onClick={() => pickDown()}><DownIcon /></button>
            </div> */}
        </div>
    )
}

export default NameCol